import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** The neutral unknown-hostname / misconfigured-tenant screen (D7). Deliberately renders no tenant
 *  name, logo, asset URL or id — only base-namespace copy — so it is safe on any hostname. Must not
 *  depend on any resolved tenant theme (D6): plain MUI defaults + `CssBaseline`, no `@app/tenant`
 *  import beyond this file staying out of it entirely. */
export const TenantNotFound = () => {
  const { t } = useTranslation('common');

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        padding: 4,
      }}
    >
      <Typography variant="h1" gutterBottom>
        {t('general.tenant.notFound.title')}
      </Typography>
      <Typography variant="body1">{t('general.tenant.notFound.description')}</Typography>
    </Box>
  );
};
